import type { CartBreakdown } from '@/types/booking';

interface GetShouldShowPayInPersonArgs {
  breakdown: Pick<CartBreakdown, 'canBookNoPay' | 'canReserve'> | undefined;
  isWaitlist: boolean;
  isCoveredByGiftCard: boolean;
}

/** Decides whether the "Pay in Person" option should be shown. */
export const getShouldShowPayInPerson = ({
  breakdown,
  isWaitlist,
  isCoveredByGiftCard,
}: GetShouldShowPayInPersonArgs): boolean => {
  const isBasicallyPayInPersonAvailable =
    !!breakdown?.canBookNoPay || !!breakdown?.canReserve;

  return isBasicallyPayInPersonAvailable && !isCoveredByGiftCard && !isWaitlist;
};
